
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Toutes les régions de Suisse ont apporté de nouvelles voix aux Verts le week-end dernier. Qu’en est-il des autres partis? Quelles communes ont influencé leurs résultats? La comparaison des votes de 2015 et de 2019 montre à quels endroits chaque parti a gagné du terrain et là où ils en ont perdu. `}</p>
    <p>{`Les cartes ci-dessous illustrent que le succès des Vert’libéraux reste limité aux grandes régions urbaines. On y voit aussi les pertes du PS dans les grandes régions de Zurich, Berne et Genève. Tout comme celles de l’UDC en Suisse romande, en Argovie et à Bâle.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;